//Routes
export const BENCHMARK_TRACKER_ROOT_ROUTE = "activation-benchmarkTracker";
export const BENCHMARK_TRACKER_REPORT_ROUTE = `${BENCHMARK_TRACKER_ROOT_ROUTE}-report`;

// URLS
export const BENCHMARK_TRACKER_ROOT_URL = "/benchmark";
export const BENCHMARK_TRACKER_REPORT_URL = `/report`;
